import Validated from 'components/util/Validated';

export { Validated as validated };



// WEBPACK FOOTER //
// src/components/util/index.js